import { queryOptions } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { ProdutoVariacaoSchema } from '../types/ProdutoVariacao';

export type ApiVariacaoConsultarParams = Partial<
    DefaultApiParams & {
        variacao: string;
    }
>;

const schema = registrosSchema(ProdutoVariacaoSchema);

export const API_VARIACAO_CONSULTAR = 'Variacao/Consultar';

function apiVariacaoConsultar(params: ApiVariacaoConsultarParams) {
    return fetchApi({
        endpoint: API_VARIACAO_CONSULTAR,
        method: 'get',
        params,
        schema,
    });
}

export function apiVariacaoConsultarQueryOptions(params: ApiVariacaoConsultarParams) {
    return queryOptions({
        queryFn: () => apiVariacaoConsultar(params),
        queryKey: [API_VARIACAO_CONSULTAR, params],
    });
}
